export const meridianInPersonLocations = [
  { label: 'West LA', value: '11835 W. Olympic Blvd. Suite 815E Los Angeles, CA 90064' },
  { label: 'Murray', value: '4516 South 700 E Suite 170 Murray, UT 84107' },
  { label: 'Tehachapi', value: '122 S Green St Suite #5, Tehachapi, CA 93561' },
];

export const soTherapyInPersonLocations = [
  { label: 'Sherman Oaks', value: '4521 Sherman Oaks Ave STE 101, Sherman Oaks, CA 91403' },
]
